import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import EmptyStateImage from './components/Image';
import UnlockButton from './components/UnlockButton';

import { userHasFeature } from '../../helpers/Features';
import LearnMoreLink from './components/LearnMoreLink';

const EmptyImageEditor = ({ handleNewItem }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Create preset sizes for your Image Editor' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'In addition to standard social media sizes, create unlimited custom preset sizes to fit your business.' })}
        </div>
        <div>
          {userHasFeature('image-editor') ? (
            <Button color="primary" className="mt-4" onClick={handleNewItem}>
              {intl.formatMessage({ defaultMessage: 'Create presets' })}
            </Button>
          ) : (
            <UnlockButton feature="image-editor" />
          )}
          <LearnMoreLink url="https://help.stockpress.co/en/articles/9341551-crop-assets-with-our-image-editor" />
        </div>
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-image-editor.png" />
    </div>
  );
};

EmptyImageEditor.propTypes = {
  handleNewItem: PropTypes.func,
};

EmptyImageEditor.defaultProps = {
  handleNewItem: () => { },
};

export default EmptyImageEditor;
